module.exports = __webpack_public_path__ + "static/img/ic_lamp_logo.784eac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b122/ic_lamp_logo.png
// module id = cmWR
// module chunks = 0